import { gql } from "@apollo/client";

export const removeUserFromAccountQuery = gql`
  mutation RemoveUser($UserId: Guid, $AccountId: Guid) {
    RemoveUser(UserId: $UserId, AccountId: $AccountId) {
      Id
    }
  }
`;
